/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Links_1_LabelInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_links_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Links_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to all GridCraft guides on the homepage`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_links_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Links_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页浏览全部 GridCraft 指南`)
};

/**
* | output |
* | --- |
* | "Return to all GridCraft guides on the homepage" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Links_1_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_links_1_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Links_1_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Links_1_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_links_1_label(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_links_1_label(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_links_1_label as "gc.search_guides.gridcraft_excel_compatibility.sections.8.links.1.label" }